import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/helperClass';

type Props = {
  text: string;
  className?: string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';
  onClick?: () => void;
  prefix?: string | ReactNode;
  maxLength?: number | 'FULL';
};

export function truncateText(text: string, maxLength: number): string {
  if (text?.length <= maxLength) return text;
  return text?.slice(0, maxLength) + '.....';
}

const InfoText = ({
  text,
  className,
  size = 'sm',
  onClick,
  prefix,
  maxLength = 150,
}: Props) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  // If maxLength is 'FULL', never truncate
  const shouldTruncate =
    typeof maxLength === 'number' && text?.length > maxLength;
  const displayText =
    maxLength === 'FULL'
      ? text
      : shouldTruncate && !isExpanded
      ? truncateText(text, maxLength as number)
      : text;

  return (
    <p
      onClick={() => onClick?.()}
      className={cn(
        `font-normal break-words max-w-full text-${size}`,
        !className?.match(/text-(\w|-)+/) && 'text-text-secondary',
        className
      )}
    >
      {prefix}
      {displayText}
      {shouldTruncate && (
        <span className="break-words ml-1">
          <button
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
            className="!font-bold text-light-text-primary hover:opacity-70 transition-opacity"
          >
            {isExpanded ? t('showLess') : t('showMore')}
          </button>
        </span>
      )}
    </p>
  );
};

export default InfoText;
